import { IAutoRegionConfig } from '../../../interfaces/auto';
import coverageConfigs from '../coverageConfigs';

const CAConfig: IAutoRegionConfig = {
  coverages: [
    coverageConfigs.ADDITIONAL_EQUIPMENT(),
    coverageConfigs.BODILY_INJURY_LIMIT(),
    coverageConfigs.COLLISION_DEDUCTIBLE(),
    coverageConfigs.COLLISION_DEDUCTIBLE_WAIVER(),
    coverageConfigs.COMPREHENSIVE_DEDUCTIBLE(),
    coverageConfigs.MEDICAL_LIMIT(),
    coverageConfigs.PROPERTY_DAMAGE_LIMIT(),
    coverageConfigs.RENTAL_REIMBURSEMENT(),
    coverageConfigs.ROADSIDE_ASSISTANCE(),
    coverageConfigs.UNINSURED_MOTORIST_BODILY_INJURY_LIMIT(),
    coverageConfigs.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIMIT({
      appliesTo: 'VEHICLE',
    }),
  ],
};

export default CAConfig;
